import client from '../../api';
import { CancelToken } from 'axios';
import qs from 'qs';

let cancel;

export const getScheduledTasksService = async (assignmentId, params) => {
  if (cancel !== undefined) {
    cancel();
  }
  if (!assignmentId) return;
  try {
    return await client.get(`/api/cna-assignments/${assignmentId}/scheduled-tasks`, {
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
      cancelToken: new CancelToken(function executor(c) {
        cancel = c;
      }),
    });
  } catch (e) {
    console.log(e);
    return e;
  }
};

export const updateScheduledTaskService = async ({ taskID, assignmentId, taskTitle, default_task_id, period_settings }) => {
  if (cancel !== undefined) {
    cancel();
  }
  if (!taskID) return;
  try {
    const body = {
      period_settings,
    };

    if (typeof default_task_id === 'number') {
      body.default_task_id = default_task_id;
    } else {
      body.name = taskTitle;
    }

    return await client.patch(`/api/cna-assignments/${assignmentId}/scheduled-tasks/${taskID}/`, body);
  } catch (e) {
    console.error(e);
    return e;
  }
};

export const deleteScheduledTaskModal = async ({ assignmentId, taskID }) => {
  if (cancel !== undefined) {
    cancel();
  }
  if (!taskID) return;
  try {
    return await client.delete(`/api/cna-assignments/${assignmentId}/scheduled-tasks/${taskID}/`);
  } catch (e) {
    console.error(e);
    return e;
  }
};
